export default __webpack_public_path__ + "static/media/statistics.bb86974e.png";